import { MedicaidService } from './medicaid.service';
import { StateToken } from '@ngxs/store';
import { BaseSmartActionStateModel } from '../../../models/smart-actions.models';
import { BaseProductStateModel } from '../base-product-state.models';


export interface MedicaidStateModel extends BaseProductStateModel {

}

export class MedicaidSmartActionsStateModel extends BaseSmartActionStateModel {

}


export const MEDICAID_TOKEN_KEY = 'medicaidState';
export const MEDICAID_TOKEN_TOKEN = new StateToken<MedicaidService>(MEDICAID_TOKEN_KEY);


export const ProductNameMedicaid = 'MEDICAID';
export const ProductNameRetention = 'MEDICAIDRETENTION';
export const ProductNameManagedRetention = 'MANAGEDMEDICAIDRETENTION';
export const ProductNamePartialToFull = 'PARTIALTOFULL';
